import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';

// Same "fetch everything once, filter client-side" shape as
// ParticipantSearchSelect.jsx - course counts are small (unlike the
// 5000-word dictionary WordSearchSelect.jsx debounces server-side for),
// so one GET on mount is enough. Reuses .participant-search-* CSS classes
// directly rather than duplicating them under a new name.
export default function CourseSearchSelect({ value, onChange, excludeIds, placeholder }) {
   const [courses, setCourses] = useState([]);
   const [query, setQuery] = useState('');
   const [open, setOpen] = useState(false);
   const wrapRef = useRef(null);
   const lang = language[language.lang];

   useEffect(() => {
      axios.get('/api/courses', { withCredentials: true })
         .then(response => setCourses(Array.isArray(response.data) ? response.data : []))
         .catch(() => setCourses([]));
   }, []);

   useEffect(() => {
      if(!value) {
         setQuery('');
      }
   }, [value]);

   useEffect(() => {
      const handleOutside = (e) => {
         if(wrapRef.current && !wrapRef.current.contains(e.target)) {
            setOpen(false);
         }
      };
      document.addEventListener('mousedown', handleOutside);
      return () => document.removeEventListener('mousedown', handleOutside);
   }, []);

   const excludeSet = new Set((excludeIds || []).map(String));
   const selected = courses.find(c => String(c.id) === String(value));

   const filtered = courses.filter(c => {
      if(excludeSet.has(String(c.id))) {
         return false;
      }
      if(!query.trim()) {
         return true;
      }
      return (c.name || '').toLowerCase().includes(query.trim().toLowerCase());
   });

   const handlePick = (course) => {
      onChange(String(course.id));
      setQuery(course.name);
      setOpen(false);
   }

   const handleInputChange = (e) => {
      setQuery(e.target.value);
      if(value) {
         onChange('');
      }
   }

   const displayValue = open ? query : (selected ? selected.name : query);

   return (
      <div className='participant-search-select' ref={wrapRef}>
         <input className='submit-field from-input txt-c participant-search-input'
            type='text' placeholder={placeholder}
            value={displayValue}
            onFocus={() => { setOpen(true); setQuery(''); }}
            onChange={handleInputChange} />
         {open ? (
            <div className='participant-search-dropdown'>
               {filtered.length === 0 ? (
                  <div className='participant-search-empty'>{lang['Empty list']}</div>
               ) : filtered.map(c => (
                  <div key={c.id} className='participant-search-option' onClick={() => handlePick(c)}>
                     {c.name}
                  </div>
               ))}
            </div>
         ) : ''}
      </div>
   );
}
